// Copyright (c) Docugami, Inc. All rights reserved.
import { UrlHashParametersState, UrlHashParametersActionTypes, SET_URL_HASH_PARAMETERS_STATE } from "./types";
import { AppDispatch } from '..';
import { ParsedQuery } from "query-string";
import * as queryString from 'query-string';

function setUrlHashParametersState(newState: UrlHashParametersState): UrlHashParametersActionTypes {
    return {
        type: SET_URL_HASH_PARAMETERS_STATE,
        payload: newState
    };
}

export const processUrlHashParameters = (urlHash: string, query: string) => (dispatch: AppDispatch) => {
    if (!urlHash && !query) {
        return Promise.resolve();
    }

    let parsedValues: ParsedQuery = {};
    if (!!urlHash) {
        parsedValues = queryString.parse(urlHash);
    }

    if (!!query) {
        parsedValues = { ...parsedValues, ...queryString.parse(query) };
    }

    const dict: { [id: string]: string } = {}
    for (const key of Object.keys(parsedValues)) {
        if (parsedValues[key] !== undefined) {
            dict[key] = parsedValues[key] as string;
        }
    }

    dispatch(setUrlHashParametersState({
        hash: urlHash ?? '',
        query: query ?? '',
        dictionary: dict
    }));

    return Promise.resolve();
}
